import {Form, Formik} from "formik";
import React from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import NsFormikScrollToError from "../../components/NsFormikScrollToError";
import NsField from "../../components/fields/NsField";

export default function ModificaFrequenzaView({
                                                  id,
                                                  show,
                                                  setShow,
                                                  modalMsg,
                                                  bottoniSx,
                                                  bottoniDx,
                                                  onSubmitForm,
                                                  formikRef,
                                                  SignupSchema,
                                                  initialFormValues,
                                              }) {

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Card
                icon={'fas fa-hourglass-start'}
                title={id ? 'Modifica Frequenza' : 'Inserisci Frequenza'}
                bottoniSx={bottoniSx}
                bottoniDx={bottoniDx}
            >
                <Formik
                    initialValues={initialFormValues}
                    innerRef={formikRef}
                    validationSchema={SignupSchema}
                    onSubmit={onSubmitForm}
                >
                    {({errors, touched, values, submitCount}) => (
                        <Form className="row g-3">
                            <div className="col-md-6">
                                <NsField
                                    name={"codice"}
                                    label={"Codice*:"}
                                    isDisabled={id}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"descrizione"}
                                    label={"Descrizione*:"}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>

                            <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                        </Form>
                    )}
                </Formik>
            </Card>
        </div>
    );
}